module.exports = __webpack_public_path__ + "img/beyond-chance-and-credence-cover.20c5734e.jpg";